<template>
  <div class="my-auto">
    <button class="btn light-bg" @click="logout">Logout</button>
  </div>
</template>

<script>
export default {
  name: "logout-button",
  methods: {
    logout: async function() {
      this.$cookies.remove("email");
      this.$cookies.remove("token");
      this.$cookies.remove("type");
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.logo {
  width: 500px;
}

button {
  padding: 10px 20px;
}
</style>